export enum RentChargeStatus {
	NotDue = 0,
	Due = 10,
	OverDue = 20,
	Paid = 30,
	Late = 40
}